<template>
	<a-layout-content :style="{ paddingTop: '0px', margin: 0, minHeight: '280px',height:'100vh' }" v-if="seltArtItem.id >= 0" class="detailmain-cls" 
		:class="className" >
	  <a-row class="detail" :class="cls1"> 
	  	<a-col  :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="detailTopTool">
	  		  <a-row>
	  			  <a-col :xs="10" :sm="10" :md="8" :lg="8" :xl="8" class="leftTool">
					  <label  @click="toHome()"><img src="@/assets/img/main/icon-tool-home.png" /> 首页</label> 
	  				  <label  @click="toBack()"><img src="@/assets/img/main/icon-prev.png" /> 返回</label>
	  			  </a-col>
				  <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="centerTool"  @click="activeDetailContent" >
					  <span style="display: none;">{{seltArtItem.title}}</span>
				  </a-col>
	  			  <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="rightTool" >
	  				  <label @click="downV(seltArtItem.file_url)" :class="downicon"><img :src="downImg" /> <span>下载</span></label>	
	  				  <template v-if="isFenPing==false">
	  					<label @click="fenPingFun()"><img src="@/assets/img/main/icon-gd.png" /> <span>固定</span></label>					  
	  				  </template>
	  				  <template v-else>
	  				  	<label class="color-blue" @click="fenPingFun()"><img src="@/assets/img/main/icon-gd-1.png" /> <span>解开</span></label>					  
	  				  </template>
	  				  <label @click="penV(seltArtItem.article_id)" :class="penicon"><img :src="penImg" /> <span>画笔</span></label>	
	  			  </a-col>
	  		  </a-row>
	  	</a-col>
	  	<a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="detailContent"  >
			<iframe ref="myIframe" :src="seltArtItem.kk_preview_url" class="iframe" />
		</a-col>
	  </a-row>	
	</a-layout-content>	
</template>

<script> 
	import {findDivElements,getArtItem,removeDivElements,removeElementByIndex,findById,findParentPath,modifyNestedArrayById,modifyNestedArrayByKeyName,findByIdNumber} from '@/utils/util';
	export default {
	  components: {
	    // TyphoonInfoTreeSelect,
	  },
	  data() {
	    return { 
	        isFenPing:false,
			cls1:"",
			id:0,
			detailContentVal:"",//GListData[0]['src'],//"http://www.baidu.com/",//详细内容
			className:"",
		    leftHieght:0,
			windowWidth: 0,
			windowHeight: 0,
			downImg:"/assets/img/main/icon-down.png",
			penImg:"/assets/img/main/icon-pen.png",
			seltArtItem3:{id:0,kk_preview_url:""},
			
			isload:false,
			downicon:"",
			penicon:"",
	    };
	  },
	  computed: { 
		  deailIdVal(){
			  return this.$store.state.article.activeDetailContent;
		  },
		  LeftHieghtVal(){
			  return this.$store.state.article.leftHieght;
		  },
		  isFenPingVal(){
			  return this.$store.state.article.isFenPing; 
		  }
	  },
	  props: {
		  //接受父组件传值 
		  //isFenPingVal:Boolean, 
		  seltArtItem:Object, 
		  deailId:String,
	  },
	  watch:{ 
		  deailIdVal(newVal){
		  	if(newVal==this.deailId)
			{
				this.className="active";
			}
			else{
				this.className="";
			}
			
		  },
		  LeftHieghtVal(newVal){
			this.leftHieght=newVal;
		  },
		  isFenPingVal(newVal){
			this.isFenPing=newVal;
		  },
	  },
	   created(){		   
		   this.$store.commit("article/set_historyId",{div1:[],div2:[]});
		   console.log("detailc-created-seltArtItem:",this.seltArtItem);
		   this.seltArtItem3=this.seltArtItem;
		   this.isload=false;
	   },
	  mounted(){
		  if(this.isFenPingVal==true)
		  {
		  	this.isFenPing=true;
			this.cls1="fenping_css";
			if(this.deailIdVal==this.deailId)
			{
			  this.className="active";
			}
		  }
		  else{
			  this.isFenPing=false;
			  this.cls1="";
		  }	
		  
		this.updateDimensions();
		window.addEventListener('resize', this.updateDimensions);
		
		var _self=this;
		console.log("_self.isload:",_self.isload);
		setTimeout(function(){
			_self.isload=true;
			console.log("_self.isload:",_self.isload);
		},1500)
		
	  },
	  methods:{
		  updateDimensions() {
			this.windowWidth = window.innerWidth;
			this.windowHeight = window.innerHeight; 
		  },
		  toHome(){			  
			  if(navigator.onLine==false)
			  {
				  this.$message.error("网络断开");
				  return;
			  }
			  console.log("detailcontent--------------toHome");
			  
			  var _self=this;
			  this.$store.commit("article/SetSearchKeyWordsTop","");
			  
			  var menulist=_self.$store.state.article.menuList;
			  this.$store.dispatch("article/getHomeAction").then(res=>{
				   var arr=findById(menulist,res.datas.id);
				   var params={
						id:arr.id,//this.$store.state.article.seltMenuItem
						page:1,
						pageSize:this.$store.state.article.pageSize, 
						istype:"curpage"
				   };
				   //var resDataDetail=_self.$store.state.article.resDataDetail;				   
				   this.$store.commit("article/set_defaultMenuItem",{id:arr.id,name:arr.name});
				   var pplist=findParentPath(menulist,arr.id); 
				   _self.$store.commit("article/set_pplist",pplist); 
				   _self.setActive3(pplist);						
				   setTimeout(function(){
						_self.$router.push({path:'/main'})
				   },500)
			  });
			  return;
		  },
	  
		  toBack(){
			 //this.$router.go(-1);	
			this.$store.commit('article/SetActiveDetailContent',this.deailId);
			 
			 var historyIdArr= this.$store.state.article.historyId;
			 var activeDivId= this.$store.state.article.activeDetailContent;				 
			 //var arr=findDivElements(historyIdArr,activeDivId);
			 console.log("this.deailId:",this.deailId);
			 console.log("historyIdArr1:",historyIdArr); 
			 if(historyIdArr.div1.length>1 || historyIdArr.div2.length>1 )
			 {		
				 //分屏状态
				 //var resData=this.$store.state.article.leftArtlist;
				 var resData=[];
				 resData=this.$store.state.article.resDataDetail;
				if(activeDivId=="div1")
				{	
					//console.log("historyIdArr.div1.length:",historyIdArr.div1.length);	
					if(historyIdArr.div1.length<=1)
					{
						 this.backToHome();
						 return;
					}
					else{ 
						var arrV=historyIdArr.div1;
						var index=arrV.length-2;//arr.length-2;
						arrV=removeElementByIndex(arrV,index+1);//
						historyIdArr.div1=arrV;
											
						var item=arrV[index];	 
						var seltArtItem=getArtItem(resData,item.id);
						this.$store.commit("article/set_seltArtItem",seltArtItem);	
						//console.log("this.deailId-seltArtItem-div1:",seltArtItem);
					}
				}
				else
				{		
					//console.log("historyIdArr.div2.length:",historyIdArr.div2.length);		
					if(historyIdArr.div2.length<=1)
					{
						 this.backToHome();
						 return;
					}	
					else
					{							
						arrV=historyIdArr.div2;
						index=arrV.length-2;//arr.length-2;
						arrV=removeElementByIndex(arrV,index+1);//
						historyIdArr.div2=arrV;
											
						item=arrV[index];	
						console.log(item.id);
						seltArtItem=getArtItem(resData,item.id);
						this.$store.commit("article/set_seltArtItem2",seltArtItem);	
						//console.log("this.deailId-seltArtItem-div2:",seltArtItem);
					}
				}		
				 this.$store.commit("article/set_historyId",historyIdArr);	
				 //console.log("historyIdArr2:",historyIdArr);
				 //console.log("this.deailId-delt["+item.id+"]:",historyIdArr);
				 //console.log("this.deailId-arr:",arr);
			 }
			 else
			 {
				 //单文档状态
				 this.backToHome();
			 }
			 //this.$router.back(); 
			 //
		  },
		  backToHome()
		  { 
			   var _self=this;
			   if(this.$route.name=="sdetail")
			   {
				   this.$router.push("/main");
				   return;
			   }
			   
			   var params={
					id:this.$store.state.article.seltMenuItem.id,
					page:1,
					pageSize:this.$store.state.article.pageSize, 
					istype:"curpage"
			   };	  
			    if(this.windowWidth>1500)
			    {
			  	 params.pageSize=8;
			  	 _self.$store.commit("article/pageSize",this.pageSize);
			    }
			   //_self.$store.dispatch("article/set_lastpage",0);
			   //_self.$store.dispatch("article/set_currentpage",0);			   
			   //_self.$store.dispatch("article/set_lastpage2",0);
			   _self.$store.dispatch("article/GetArticleList",params); //当前页	
			   
			   var seltArtItem=this.seltArtItem3;
				   
			   var menulist=_self.$store.state.article.menuList;
			   var pplist=findParentPath(menulist,seltArtItem.article_class_id);//_self.$store.state.article.pplist;
			   this.$store.commit("article/set_pplist",pplist); 
			   console.log("detailcontent---backToHome--menulist:",menulist);
			   console.log("detailcontent---backToHome--pplist:",pplist);
			   console.log("detailcontent---backToHome--seltArtItem:",seltArtItem);
			   this.setActive3(pplist);	
			   //console.log("menulist:",menulist);
			   //var pplist=();
			   this.$router.push("/main");
			  //  setTimeout(function(){
				 // _self.isload=false;
			  //  	 _self.$router.push({path:'/main'})
			  //  },500)
		  },		  
		  setActive3(pplist,setDefault=0)
		  {
		  			  
			  var menuListData=this.$store.state.article.menuList;
			  console.log("detailcontent-----pplist:",pplist);
			  console.log("detailcontent-----menuListData:",menuListData);
			  menuListData=modifyNestedArrayByKeyName(menuListData,"class3","active3",function(node){
					node.class3=""
			  });			  
			  if(pplist.length>0)
			  {
				  var ival=pplist[pplist.length-1];			  
				  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
					node.class3="active3"
				  });
			  }
			  this.$store.commit("article/set_menuList",menuListData);			  
			  this.$store.commit("article/set_seltMenuItem",pplist[pplist.length-1]);
			  //console.log("setActive3----------------menuListData:",menuListData);
		  },
		  //分屏
		  fenPingFun(){
			 if(this.isFenPing==false)
			 {
				 //分屏
				 this.isFenPing=true;
				 this.cls1="fenping_css";
				 this.$store.commit('article/set_isFenPing',this.isFenPing);
				 this.$store.commit('article/SetActiveDetailContent',this.deailId);
				 
				 //var resData=this.$store.state.article.leftArtlist;
				 var resData=this.$store.state.article.resDataDetail;
				 var seltArtItem2=this.$store.state.article.seltArtItem2;				 
				 var seltArtItem=this.$store.state.article.seltArtItem;
				 var curIndex=resData.findIndex(item => item.id === seltArtItem.id);
				 console.log("this.deailId:",this.deailId);
				 console.log("seltArtItem2:",seltArtItem2);
				 console.log("seltArtItem:",seltArtItem);
				 if(seltArtItem.id==undefined)
				 {
					seltArtItem=seltArtItem2;					
					 if(curIndex==(resData.length-1))
					 {
						 //最后一个
						 seltArtItem=resData[resData.length-2];
					 }
					 else{
						seltArtItem=resData[curIndex+1];
					 }
					this.$store.commit('article/set_seltArtItem',seltArtItem);
				 }
				 if(seltArtItem2.id==undefined)
				 {
				 	seltArtItem2=seltArtItem;					
					//console.log(curIndex);
					this.$store.commit('article/set_seltArtItem2',seltArtItem2);
					this.$store.commit('article/SetActiveDetailContent',"div2");
				 }
			 }
			 else{
				 //不分屏
				 this.isFenPing=false;
				 this.cls1="";
				 this.$store.commit('article/set_isFenPing',this.isFenPing);
				 console.log("this.deailId:",this.deailId);//需要关闭的
				 if(this.deailId=="div1")
				 {
					 //需要关闭的 div1					 
					 this.$store.commit('article/SetActiveDetailContent',"div2");
					 var seltArtItem22=this.$store.state.article.seltArtItem2;
					 this.$store.commit("article/set_seltArtItem",[]);
				 }
				 else
				 {
					 this.$store.commit('article/SetActiveDetailContent',"div1");
					 var seltArtItem11=this.$store.state.article.seltArtItem;
					 this.$store.commit("article/set_seltArtItem2",[]);
				 }
			 }
			 this.$emit('fenping-event', this.isFenPing);//this.$emit('事件名',要传的数据)
		  },
		  activeDetailContent()
		  {
			  this.className="active";
			  this.$store.commit('article/SetActiveDetailContent',this.deailId);
		  },
		  //下载
		  downV(str){
			  console.log("文件下载：",str);
			  const link = document.createElement('a');
			  link.href =str;
			  link.download = 'custom-filename.pdf';
			  document.body.appendChild(link);
			  link.click();
			  document.body.removeChild(link);
				  
			  this.penImg="/assets/img/main/icon-pen.png"; 
			   this.penicon="";
			  if(this.downicon=="")
			  {
					this.downicon="active11"
					this.downImg="/assets/img/main/icon-down-1.png";
			  }
			  else{
					this.downicon="";
					this.downImg="/assets/img/main/icon-down.png";
			  }
		  },
		  //画笔
		  penV(str){
			  console.log("画笔：",str);
			  this.downImg="/assets/img/main/icon-down.png";
			  this.downicon="";
			  if(this.penicon=="")
			  {
					this.penicon="active22"
					this.penImg="/assets/img/main/icon-pen-1.png"; 
			  }
			  else
			  {
					this.penicon="";
					this.penImg="/assets/img/main/icon-pen.png"; 
			  }
		  },
	  },
	};
</script>

<style lang="scss" scoped> 
	.detailmain-cls{  overflow: hidden;max-height: 87vh;}
	.ant-layout-content{
		background-color: #fff!important;
		border-radius:15px ;
		.detail{  
			width:auto; height: 699px; margin: 0px auto;
			padding-left: 19px; padding-right: 19px; padding-bottom: 18px; padding-top: 13px; 
		}
		.fenping_css{
			padding-left: 19px; padding-right: 19px; padding-bottom: 18px; padding-top: 12px;
			.rightTool {
				label{
					width: auto; margin-left: 8px;
					span{display: none;}
				}
			}
			
		}
	}
	.detailTopTool{
		height: 24px; position: relative;
		font-size: 14px;line-height: 24px;
		color:#333;font-weight: 550;
		img{ max-width:24px; max-height: 24px;float: left; margin-right: 4px; }
		.leftTool{
			text-align: left; cursor: pointer;color: rgba(25, 26, 26, 1);
			img{width:18px;height:18px; margin-left:2px;margin-top: 3px; float: left;}
			label{height: 24px; position: relative;display: block; float: left;}
			label:nth-child(1){width: 60px; margin-right:0px;} 
		}
		.centerTool{ height:100%; min-height: 30px;}
		.rightTool{
			text-align: right; cursor: pointer;color: rgba(101, 101, 102, 1);
			label{ width: 56px;height: 24px; position: relative;display: block; float: right; margin-left: 24px;} 
			.color-blue{color:rgba(31, 110, 238, 1)}
		}
	}
	.detailContent{
		height: 78.5vh; overflow: hidden;
		min-height: 250px; 
		display: flow-root;
		position: relative;
		margin-top: 10px;
		
	}
	.active{ border:solid 2px rgba(31, 110, 238, 1);}
	.active22 span,.active11 span{color:rgba(31, 110, 238, 1);}
</style>
<style>
	iframe {
	  /* 其他样式 */
	  overflow-y: scroll; /* 仅垂直滚动 */
	  width: 100%; height: 100%; border: solid 1px #eee;max-height: 99vh;
	}
	 
	iframe::-webkit-scrollbar {
	  width: 12px; /* 滚动条宽度 */
	}
	 
	iframe::-webkit-scrollbar-track {
	  background: #f1f1f1; /* 滚动条轨道颜色 */
	}
	 
	iframe::-webkit-scrollbar-thumb {
	  background-color: #888; /* 滚动条滑块颜色 */
	  border-radius: 10px; /* 滑块圆角 */
	  border: 3px solid #f1f1f1; /* 滑块边框 */
	}
	 
	iframe::-webkit-scrollbar-button:single-button {
	  background-color: #aaa; /* 按钮颜色 */
	  display: block; /* 显示按钮 */
	}
</style>